export default {
  allCounterparties: state => state.counterparties || [],
  allCounterpartiesHistory: state => state.counterpartiesHistory || [],
  allCounterpartyTypes: state => state.counterpartyTypes || [],
  allDirectoryLegalForms: state => state.directoryLegalForms || [],
  allCounterpartyAddressTypes: state => state.counterpartyAddressTypes || [],
  getCurrentCounterpartyIdInDB: state => state.currentCounterpartyIdInDB || {},
  getAddedAdresses: state => state.addedAdresses || [],
  getCounterpartiresForContract: state => state.counterpartiesForContract || [],
  getAvalableAdressTypes: state => {
    let avalableAdressTypes = [];

    for (let i = 0; i < state.counterpartyAddressTypes.length; i++) {
      const element = state.counterpartyAddressTypes[i];
      const isContain = state.selectedAddressTypes.some(a => a.addressFullName === element.addressFullName);
      if(!isContain){
        avalableAdressTypes.push(state.counterpartyAddressTypes[i]);
      }
    }
    return avalableAdressTypes;
  }
};
